export const createMenuItems = (data: any[], key: string) => {
  let menuItems = [];
  if (data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      let obj = data[i];
      let text = obj[`${key}`];

      if(text === text.toUpperCase()){
        menuItems.push({ id: obj.id, text: text });
      }
      else {
        let itemText = text.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
        menuItems.push({ id: obj.id, text: itemText });
      }
    }
  }
  return menuItems;
};

export const createStandardMenuItems = (data: any[], key: string) => {
  let menuItems = [];
  if (data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      let obj = data[i];
      let text = obj[`${key}`];
      menuItems.push({ id: obj.id, text: text });
    }
  }
  return menuItems;
};
